
Vue.component('catalog-tree', {
	template:
		'<div class="list">\n' +
		'    <div class="group" v-for="(item,index) in list" :key="index">\n' +
		'        <div class="name-box" :style="{paddingLeft:paddingLeft}" @click="setIsOpen(item)">\n' +
		'            <template v-if="item.list&&item.list.length>0">\n' +
		'                <span class="icon icon-jia" v-if="!item.isOpen" ></span>\n' +
		'                <span class="icon icon-jian" v-else ></span>\n' +
		'            </template>\n' +
		'            <template v-else>\n' +
		'                <span class="icon icon-jian" style="visibility: hidden;"></span>\n' +
		'            </template>\n' +
		'			<div class="title-time-box" v-if="item.type==\'video\'">\n' +
		'				<div class="title">{{item.name}}</div>\n' +
		'				<div class="time-speed">\n' +
		'					<span class="desc">时长：{{item.duration}}分钟</span>\n' +
		'					<div class="speed-box">\n' +
		'						<div class="speed" :style="{width: item.percentStr,}"></div>\n' +
		'					</div>\n' +
		'					<span class="desc">{{item.percentStr}}</span>\n' +
		'				</div>\n' +
		'				<div class="btn btn-hover">开始学习</div>\n' +
		'			</div>\n' +
		'			<div class="title" v-else>{{item.name}}</div>\n' +
		'        </div>\n' +
		'           <catalog-tree v-if="item.isOpen && item.list&&item.list.length>0" :data="item.list" :order-id="orderId" :current="current+1"></catalog-tree>\n' +
		'    </div>\n' +
		'</div>',
	data() {
		return {
			isOpen: false,
			list: [],
		}
	},
	computed: {
		paddingLeft: function () {
			return (this.current * 18) + 'px'
		}
	},
	props: {
		orderId: {
			type: [Number, String],
			default: null,
		},
		data: {
			type: Array,
			default: function () {
				return []
			}
		},
		current: {
			type: [Number],
			default: 0,
		}
	},
	watch: {
		data: {
			handler: function (val) {
				this.list = JSON.parse(JSON.stringify(val));
			},
			immediate: true
		}
	},
	methods: {
		setIsOpen(item) {
			if (item.liveVideoId) {
				let orderId = this.orderId;
				let url = '/pages/live/video.html?id='+item.liveVideoId + '&orderId='+orderId + '&structureId='+item.structureId;
				window.open(url)
			} else {
				item.isOpen = !item.isOpen
			}
		}
	}
})

const vueInst = new Vue({
	el: '#vue-wrap',
	data: {
		authSetUrl: authSetUrl,
		majors: JSON.parse(localStorage.majors),
		loginFlag: null,
		firstFlag: false,
		bdList: [],
		fList: [],

		cid: null,
		user: {},
		myCourseList: [],
		courseList: [],
		emptyFlag: false,
		classList: [],
		freeList: [],
		type: 1,
		lastV: null,
		lastVideo: null,
		liveList: [],

		orderList: [],
		subjectTypeList: [],
		currentOrder: {

		},
		subjectTypeId: null,
		catalogTreeData: [],
		extensionPopup: false,

		isExtensionList: false,
		showViewer: false,
		viewerList: [],

		identityPicture: '',
		identityPictureTips: '',
		identityPictureUrl:'',
		identityPictureProgress: 100,
		cause: 1,
		causeTips: '',
		elseCause: '',
		elseCauseTips: '',
		examPicture: '',
		examPictureTips: '',
		examPictureUrl:'',
		examPictureProgress: 100,

		extensionList:[],
		newLiveList:[],
	},
	methods: {
		selectMajor: function (id) {
			switch (id) {
				case 11:
				case 71:
				case 13:
				case 91:
					axios.post(baseURL + 'upLastMajor?mid=' + id)
						.then(res => {
							if (res.code == 200) {
								location.href = location.href.split('.html')[0] + '.html';
							}
						})
						.catch(err => console.log(err));
					break;
				case 1:
					window.open('https://www.zgjan.com/jzs1.html');
					break;
				case 2:
					window.open('https://www.zgjan.com/jzs2.html');
					break;
				case 67:
					window.open('https://www.zgjan.com/yjzj.html');
					break;
				case 70:
					window.open('https://www.zgjan.com/ejzj.html');
					break;
				case 10:
					window.open('https://www.zgjan.com/jianli.html');
					break;
				case 65:
					window.open('https://www.zgjan.com/zjjj.html');
					break;
				case 64:
					window.open('https://www.zgjan.com/cjjj.html');
					break;
				case 69:
					window.open('https://www.zgjan.com/zjkj.html');
					break;
				case 68:
					window.open('https://www.zgjan.com/cjkj.html');
					break;
				default:
					break;
			}
		},
		logout: function () {
			axios.post(baseURL + 'loginout')
				.then(res => {
					if (res.code == 200) {
						localStorage.psw = '';
						location.reload();
					}
				})
				.catch(err => console.log(err));
		},


		// 检测登录
		checkLogin: function (user) {
			console.log(user,'user')
			this.user = user;
			if(user.last_major_id==11 || user.last_major_id==71){
				this.getOrderList();
				this.getToDayList();
			}

			this.getMyCourse(user.last_major_id)
				.then(res => {
					this.getClass(res)
				});
		},
		// 获取科目
		getMyCourse: function () {
			axios.post(baseURL + 'getmyCourse')
				.then(res => {
					if (res.code == 200) {
						this.user = res.au;
						if(this.user.last_major_id==11 || this.user.last_major_id==71){
							this.getOrderList();
							this.getToDayList();
						}
						if (this.user.last_major_id === 0) {
							this.firstFlag = true;
						} else {
							this.majors.forEach(gItem => {
								gItem.list.forEach(item => {
									if (item.mid == this.user.last_major_id) {
										this.user.last_major_name = item.mt
									}
								})
							})

							res.gslist.splice(4);
							this.bdList = res.gslist;
							this.fList = res.friendlink;

							if (!this.user.last_major_id) {
								this.firstFlag = true
								return
							}

							if (res.flist && res.flist.length) {
								res.flist.forEach(item => {
									const reg = new RegExp('-', 'g')
									const startTime = new Date(item.start_time.replace(reg, '/'));
									const currentTime = new Date(item.currentime.replace(reg, '/'));

									item.start = startTime.getTime() - currentTime.getTime() < 0;

									item.time = item.start_time.split(' ')[1].split(':')[0] + ':' + item.start_time.split(' ')[1].split(':')[1]
								});

								this.liveList = res.flist;
							}

							if (res.glist && res.glist.length) {
								if (res.lastVideo) {
									// 有记录
									this.lastV = res.lastVideo
									res.glist.forEach(item => {
										if (item.gid === this.lastV.gid) {
											item.isActive = true;
											this.cid = item.gid;
										} else {
											item.isActive = false;
										}
									});
									if (!this.cid) {
										this.cid = res.glist[0].gid;
									}
								} else {
									// 没记录默认第一个
									res.glist.forEach((item, index) => {
										item.isActive = index === 0;
									});
									this.cid = res.glist[0].gid;
								}

								this.myCourseList = res.glist;
								this.getClass(this.cid)
							} else {
								this.emptyFlag = true;
							}
						}
					}
					if (res.code == -3) {
						this.goLogin()
					}
				})
				.catch(err => console.log(err));
		},
		getCourse: function (id) {
			return new Promise(resolve => {
				axios.post(baseURL + 'getCourseByMid?mid=' + id)
					.then(res => {
						if (res.code == 200) {
							if (res.list.length) {
								res.list.forEach((item, index) => {
									item.isActive = index === 0;
								});
								this.courseList = res.list;
								resolve(this.courseList[0].gid);
							} else {
								this.emptyFlag = true;
							}
						}
					})
					.catch(err => console.log(err));
			})
		},
		// 获取课程
		getClass: function (id) {
			axios.post(baseURL + 'getVideoBygidzbmk?gid=' + id)
				.then(res => {
					if (res.code == 200) {
						if (res.typelist) {
							if (res.lastVideo) {
								this.lastV = res.lastVideo;
								// 有记录
								res.typelist.forEach(item => {
									item.isActive = false;
									if (item.zjblist) {
										item.zjblist.forEach(zItem => {
											zItem.isActive = false;
											zItem.flist.forEach(fItem => {
												if (fItem.id == this.lastV.vid) {
													item.isActive = zItem.isActive = true;
													item.isLast = zItem.isLast = fItem.isLast = true;
													this.lastVideo = fItem
												}
											});
										});
									} else {
										item.zjblist = []
									}
								});
							} else {
								// 没记录默认第一个有视频的
								let foldFlag = false;
								res.typelist.forEach((item, index) => {
									item.isActive = false;
									if (item.zjblist) {
										item.zjblist.forEach((zItem, zIndex) => {
											zItem.isActive = false;
											zItem.flist.forEach(fItem => {
												if (!foldFlag) {
													item.isActive = zItem.isActive = true;
													foldFlag = true;
												}
											});
										});
									} else {
										item.zjblist = []
									}
								});
								this.lastVideo = null
							}

							this.classList = res.typelist;
						}
						this.myCourseList.forEach(item => {
							item.isActive = item.gid == id;
						});
						this.cid = id;
					}
				})
				.catch(err => console.log(err));
		},
		getVideos: function (item) {
			if (item.zjblist.length || item.emptyFlag) {
				item.isActive = !item.isActive
			} else {
				axios.post(baseURL + 'getVideoBysmallgid?gid=' + item.gid)
					.then(res => {
						if (res.code == 200) {
							if (res.zjblist && res.zjblist.length) {
								res.zjblist.forEach(zItem => {
									zItem.isActive = false

									item.zjblist.push(zItem)
								})
							} else {
								item.emptyFlag = true
							}

							item.isActive = !item.isActive
						}
					})
					.catch(err => console.log(err));
			}
		},
		// 获取试听
		getFree: function (course) {
			let id = course.id;
			if (this.user.last_major_id == 71 || this.user.last_major_id == 91) {
				id = course.dycid;
			}
			axios.post(baseURL + 'getGradeSt?cid=' + id)
				.then(res => {
					if (res.code == 200) {
						this.freeList = res.list || [];
						this.courseList.forEach(item => {
							item.isActive = item.id == id || item.dycid == id;
						});
						this.cid = id;
					}
				})
				.catch(err => console.log(err));
		},
		changeTab: function (type) {
			if (type == 1) {
				if (this.myCourseList.length) {
					this.getClass(this.myCourseList[0].gid);
				}
			} else {
				if (this.courseList.length) {
					this.getFree(this.courseList[0]);
				} else {
					this.getCourse(this.user.last_major_id)
						.then(() => {
							this.getFree(this.courseList[0]);
						});
				}
			}
			this.type = type;
		},
		changeCourse: function (course) {
			this.type == 1 ? this.getClass(course.gid) : this.getFree(course);
		},
		// 跳转详情
		goDetail: function (item) {
			if (item.pu) {
				window.open(item.pu);
			} else {
				const id = item.id || item.vid
				window.open('pages/class/playc.html?'
					+ 'id=' + id
					+ '&smallgid=' + item.gid
					+ '&cid=null'
					+ '&gid=' + this.cid
					+ '&mid=' + this.user.last_major_id
					+ '&type=' + this.type);
			}
		},
		getXetUrl: function (id) {
			var gid = this.cid;
			axios.post(baseURL + 'getByVIdGmk?gid=' + gid + '&vid=' + id)
				.then(function (res) {
					// console.log(res,'res')
					if (res.code == 200) {
						if (res.url) {
							// window.open(res.url)
							window.location.href = res.url
						} else if (res.pu) {
							window.location.href = res.pu
						}
					}
				})
		},
		getOrderList() {
			request.post('/api/edu/crm/order/getStudentOrder').then(res => {
				this.orderList = res.data;
			})
		},
		setCurrentOrder(index) {
			let item = this.orderList[index];
			this.currentOrder = item;
			this.getSubjectTypeList()
			this.getCatalog();
		},
		orderBack() {
			this.currentOrder = {};
			this.subjectTypeId = null;
		},
		getSubjectTypeList() {
			let formData = {
				orderId: this.currentOrder.orderId,
			}
			request.post('/api/edu/crm/order/getSubjectTypeList', formData).then(res => {
				let list = res.data;
				this.subjectTypeList = list;
			})
		},
		changeSubjectType(item) {
			if (this.subjectTypeId == item.id) {
				this.subjectTypeId = null;
			} else {
				this.subjectTypeId = item.id;
			}
			this.getCatalog();
		},
		getCatalog() {
			let formData = {
				orderId: this.currentOrder.orderId,
				subjectTypeId: this.subjectTypeId,
			}
			request.post('/api/edu/teaching/clientLive/getLiveCatalog', formData).then(res => {
				let list = res.data.list || [];
				this.catalogTreeData = list
			})
		},
		fileClick(type) {
			this.fileType = type;
			this.$refs.fileInput.value = null
			this.$refs.fileInput.click();
		},
		fileChange(e) {
			console.log(e, 'e')
			let files = e.target.files;
			if (!files.length) return
			let file = files[0]
			if (file.size > 5 * 1024 * 1024) {
				this.message.default.warning('图片最大支持5M')
				e.target.value = null;
				return
			}
			if (!['jpg', 'jpeg', 'png', 'gif'].includes(getSuffix(file.name, 1))) {
				this.$message.warning('只能上传jpg, jpeg, png, gif格式的图片')
				e.target.value = null;
				return
			}
			var that = this;
			if (that.uploadLock) { return }
			that.uploadLock = true;
			file.path = 'crm/screenshot'
			var fileType = this.fileType;
			uploadAction(file, progressCallback).then(res => {
				console.log(res, 'res')
				  this[fileType]= res.data;
				  this[fileType+'Url']= res.url;
				that.uploadLock = false;
			}).catch(err => {
				that.uploadLock = false;
			})

			function progressCallback(e) {
				var pro = Math.round((e.loaded / e.total) * 100);
				that[fileType+'Progress'] = pro;
			}
		},
		openViewer(url) {
			this.viewerList = [url]
			this.showViewer = true;
			this.prevOverflow = document.body.style.overflow;
			document.body.style.overflow = 'hidden';
			this.showViewer = true;
		},
		closeVidwer() {
			document.body.style.overflow = this.prevOverflow;
			this.showViewer = false;
		},
		openExtensionPopup(index){
			let item = this.orderList[index];
			this.extensionOrder = item;
			this.extensionPopup = true
			this.getExtensionList();
		},
		getExtensionList(){
			var formData = {
				orderId:this.extensionOrder.orderId
			}
			request.post('/api/edu/teaching/orderClass/getPostponeListByOrderId', formData).then( (res)=> {
				// console.log(res,'res')
				this.extensionList = res.data;
			})
		},
		extensionApplyTap(){
			var arr = [ this.verificationInput('identityPicture', '请上传身份资料'),this.verificationInput('cause', '请选择延迟原因')];
			if(this.cause==1){
				arr.push(this.verificationInput('examPicture', '点击上传分数截图'))
			}else{
				arr.push(this.verificationInput('elseCause', '请输入申请延期理由'))
			}
			if (arr.includes(false)) { return }
			
			var formData = {
				orderId:this.extensionOrder.orderId,
				identityPicture:this.identityPicture,
				cause:this.cause,
				elseCause:this.elseCause,
				examPicture:this.examPicture,
			}
			if (this.lock) { return }
			this.lock = true;
			var that = this;
			request.post('/api/edu/teaching/orderClass/applyClassPostpone', formData).then(function (res) {
				message.default.success('申请成功')
				that.identityPicture = '';
				that.identityPictureUrl = '';
				that.cause = 1;
				that.elseCause = '';
				that.examPicture = '';
				that.examPictureUrl = '';
				that.getExtensionList();
				that.lock = false;
			}).catch(function (err) {
			  	that.lock = false;
			})
		},
		getToDayList: function() {
            let formData = {
				page: this.page,
                size:this.rows,
                subjectTypeId:null,
				type: 1,
				days:0,
			}
			request.post('/api/edu/teaching/orderClass/recentlyLive', formData).then(res => {
                // console.log(res,'res')
				let list = res.data.records || [];
                let total = res.data.total;
                for (let i = 0; i < list.length; i++) {
					let item = list[i];
					item.url = '/pages/live/video.html?id='+item.liveVideoId + '&orderId='+item.orderId + '&structureId='+item.structureId;
				}
                this.newLiveList = list;
                // this.totalPage = Math.ceil(total / this.rows);
			})
        },
		goOld: function(){
			window.localStorage.setItem('classversion','old')
			window.location.href = '/pages/olduser/class.html'
		}
	},
	created: function () {
		if(window.localStorage.getItem('classversion')=='old'){
			window.location.href = '/pages/olduser/class.html'
		}
		this.getMyCourse()
	}
});